/**
 * Константы стратегии свежести и браузерных уведомлений Inbox.
 *
 * Контракт inbox §C.4.4 (Q-INB-1 resolved, `architecture.md` §5.2). Значения
 * подобраны архитектором и зафиксированы в AC-INB-009.2/.3:
 *
 * - `POLL_INTERVAL_MS` — базовый polling-интервал (75 сек, среднее диапазона 60–90).
 * - `POLL_BACKOFF_MS` — экспоненциальный backoff при ошибках refetch (75→150→300).
 * - `POLL_MAX_INTERVAL_MS` — потолок backoff (5 минут).
 * - `REFETCH_THROTTLE_MS` — минимальный интервал между focus-triggered refetch (10 сек).
 * - `NOTIF_SUMMARY_THRESHOLD` — порог аккумуляции шторма (Q-INB-2: 3+ новых → summary).
 *
 * Polling запускается только при `!document.hidden` (AC-INB-009.2); свёрнутая вкладка
 * не опрашивается (свежесть в фоне — backlog SW + Push API, концепция §7.5).
 */

export const POLL_INTERVAL_MS = 75_000; // 75 сек
export const POLL_BACKOFF_MS = [75_000, 150_000, 300_000] as const; // экспоненциальный
export const POLL_MAX_INTERVAL_MS = 300_000; // потолок 5 мин
export const REFETCH_THROTTLE_MS = 10_000; // min 10 сек между focus-triggered
export const NOTIF_SUMMARY_THRESHOLD = 3; // Q-INB-2: 3+ новых → summary-уведомление

/** localStorage-ключи клиентских преференсов (REQ-INB-010, §C.7.3). */
export const INBOX_PREF_BROWSER_NOTIFICATIONS = 'sintra.inbox.browserNotifications'; // 'on'/'off', default 'on'
export const INBOX_PREF_NOTIFICATION_BODY = 'sintra.inbox.notificationBody'; // 'on'/'off', default 'off' (privacy-default, ARCH-SEC-INB-002)
